/* Hover pan lock — port of the toolkit's map-hover-pan-lock.js (map-polish
   module, #1046 Wave A).

   Hovering a property card focuses its marker, and focusMarker pans whenever
   the pin sits outside the central "safe" bounds of the current view. So
   merely grazing the card list reshuffles the very map view the visitor was
   reading — and with search-as-move enabled the (programmatic-pan-guarded)
   reshuffle is still a visible jump on every hover. Airbnb highlights the
   pin and leaves the map alone; so does this.

   Desktop-scoped by gating on (hover: hover), toolkit rule verbatim:
   touch-ONLY devices never truly hover cards, and their emulated hover
   events — a tap on a card — keep the pan, which is genuinely useful there
   (the visitor asked about THAT property; showing its pin is the point).
   Known hole, inherited from the toolkit gate: a HYBRID device (touchscreen
   laptop) matches (hover: hover), so a tap there highlights without panning.
   A per-event answer needs the pointer type from the card's own handler
   (pointerenter → pointerType), i.e. intent decided at the call site —
   the same shape a future non-hover caller (a "show on map" button,
   deep-link arrival focus) would need, since this predicate sniffs the
   device, not the gesture. Today's only callers are card mouseenter.

   Unlike the toolkit — a deferred script that has to no-op panTo via Leaflet
   and Google prototype wraps because the plugin builds its map in a closure —
   the widget owns focusMarker, so the pan branch simply consults this
   predicate. Every other pan (pin click, fit bounds, search-as-move) never
   reaches it. */

/** True when card hover must keep its hands off the map viewport. */
export function hoverPanLocked(): boolean {
  // No matchMedia (very old engines, some test environments) → the toolkit
  // module deactivates itself and the pan proceeds; mirror that.
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false
  try {
    return window.matchMedia('(hover: hover)').matches
  } catch {
    return false
  }
}
